//E.g Pandabuy, CSSBuy
export const AgentName = 'Superbuy';
export const SecondAgentName = "Cnfans"

//Webpage title
export const PageTitle = 'superbuy spreadsheet';


